import moment from 'moment';
import momenttz from 'moment-timezone';
import { useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import ContactForm from '../ContactUs/ContactForm';
import ThankYouScreen from '../ThankYouScreen';
import { convert_date_by_tz } from '../utilities';
import WidgetWrapper from '../WidgetWrapper';
import {
  bookAppointment,
  getAvailablePropertyHours,
  getProperty,
  getPropertySupabase,
  getMagnetTemplate,
} from './utils';
import CobrowseIO from 'cobrowse-sdk-js';
import './Scheduler.css';

CobrowseIO.license = 'quGBhRTXlDPITg';
CobrowseIO.trustedOrigins = [
  'https://embed.tour.video',
  'https://tour.video',
  'https://hi.tour.video',
  'https://app.usetour.com',
  'https://usetour.com',
  'https://my.leasemagnets.com',
  'https://leasemagnets.com',
  'https://tour.video',
  'https://usetour.com',
  'https://theoneannarbor.com',
  '*',
];
CobrowseIO.start();

const Scheduler = ({ onBack, scheduleType, showGoBack }) => {
  const [step, setStep] = useState(1);
  const [selectedTourType, setSelectedTourType] = useState(
    scheduleType ? scheduleType : 'in-person'
  );
  const [selectedScheduleDate, setSelectedScheduleDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedHour, setSelectedHour] = useState('');
  const [availablepropertyhours, setavailablepropertyhours] = useState([]);
  const [propertyInfo, setPropertyInfo] = useState('');
  const [CommunityData, setCommunityData] = useState('');
  const [userInfo, setUserInfo] = useState({});
  const [isAppointmentLoading, setIsAppointmentLoading] = useState(false);
  const [magnetSettings, setMagnetSettings] = useState({});
  const [expandedAccordion, setExpandedAccordion] = useState(null);
  const [customNotes, setCustomNotes] = useState('');
  
  const { magnetId } = useParams();
  const query = new URLSearchParams(window.location.search);
  const [entratauser, seentratauser] = useState(query.get('entratauser'));
  const [entratapass, setentratapass] = useState(query.get('entratapass'));
  const [entratapropertyId, setentratapropertyId] = useState(
    query.get('entratapropertyId')
  );
  
  console.log('propertyinfo', propertyInfo);
  console.log('entrata_creds', { entratauser, entratapass, entratapropertyId });

  useEffect(() => {
    if (entratauser && entratapass && entratapropertyId) {
      (async () => {
        const propertyData = await getProperty();
        setPropertyInfo(propertyData);
      })();
    }
  }, [entratauser, entratapass, entratapropertyId]);

  useEffect(() => {
    (async () => {
      await getMagnetTemplate(
        magnetId,
        setMagnetSettings,
        entratauser,
        seentratauser,
        entratapass,
        setentratapass,
        entratapropertyId,
        setentratapropertyId
      );
    })();
  }, []);

  useEffect(() => {
    setavailablepropertyhours(
      getAvailablePropertyHours(selectedScheduleDate, propertyInfo)
    );
  }, [selectedDate, propertyInfo]);
  
  const timezone = query.get('timezone') || 'EST';
  const saturdaystatus = query.get('saturdaystatus');
  const sundaystatus = query.get('sundaystatus');

  console.log({ query, saturdaystatus, sundaystatus });

  // Timezone options mapping
  const getTimezoneDisplayName = (tz) => {
    const timezoneMap = {
      'EST': 'Eastern Time (EST)',
      'CST': 'Central Time (CST)', 
      'MST': 'Mountain Time (MST)',
      'PST': 'Pacific Time (PST)',
      'America/New_York': 'Eastern Time (EST)',
      'America/Chicago': 'Central Time (CST)',
      'America/Denver': 'Mountain Time (MST)',
      'America/Los_Angeles': 'Pacific Time (PST)',
      'America/Phoenix': 'Mountain Time (MST)',
    };
    return timezoneMap[tz] || tz;
  };

  const handleSubmitContactForm = async () => {
    // Prevent duplicate submissions
    if (isAppointmentLoading) {
      console.log('Submission already in progress, ignoring duplicate call');
      return;
    }

    // Add timestamp to track when this function is called
    const submissionTimestamp = Date.now();
    console.log(`🚀 BOOKING ATTEMPT STARTED - Timestamp: ${submissionTimestamp}`);
    console.log('📋 Form submission data:', {
      userInfo,
      selectedTourType,
      selectedDate,
      selectedHour,
      timezone,
      customNotes,
      magnetId
    });

    setIsAppointmentLoading(true);
    let created_date = await convert_date_by_tz(
      new Date(),
      timezone ? timezone : 'MST'
    );

    var tzOffsets = {
      GMT: '+00:00',
      EDT: '-04:00',
      EST: '-04:00',
      CDT: '-05:00',
      CST: '-06:00',
      MDT: '-06:00',
      MST: '-07:00',
      PDT: '-07:00',
      PST: '-08:00',
    };

    function reverseTimezone(timezone) {
      let currentOffset = tzOffsets[timezone];
      let offsetDirection = currentOffset.charAt(0);

      if (offsetDirection === '+') {
        currentOffset = '-' + currentOffset.substring(1);
      } else if (offsetDirection === '-') {
        currentOffset = '+' + currentOffset.substring(1);
      }

      return currentOffset;
    }

    try {
      // Enhanced tour summary with custom notes
      const baseTourSummary = `Tour Type: ${
        selectedTourType == 'in-person' ? 'In-Person' : 'Virtual'
      } Tour. Tour Scheduled from Leasemagnets. Scheduled 30 Minute Appointment on ${moment(
        selectedDate
      ).format('L')} at ${selectedHour}`;
      
      const finalTourSummary = customNotes 
        ? `${baseTourSummary}. Additional Notes: ${customNotes}`
        : baseTourSummary;

      console.log('Starting appointment booking process...');
      console.log('User Info:', userInfo);
      console.log('Tour Type:', selectedTourType);
      console.log('Date/Time:', selectedDate, selectedHour);
      console.log('Timezone:', timezone);

      const isBookingSuccessful = await bookAppointment(
        magnetId,
        {
          metadata: [
            {
              lead_type: 'Tour',
              tour_timezone: timezone,
              tour_time_start: moment(
                `${moment(selectedDate).format('L')} ${selectedHour}`,
                'MM/DD/YYYY hh:mm A'
              )
                .utcOffset(reverseTimezone(timezone))
                .toISOString(),
              tour_time_start_originating_timezone: `${moment(
                selectedDate
              ).format('L')} ${selectedHour}`,
              tour_date: moment(selectedDate).format('MMM DD'),
              tour_time_from: selectedHour,
              tour_time_to: moment(selectedHour, 'hh:mm A')
                .add(30, 'm')
                .format('hh:mm A'),
              tour_type:
                selectedTourType == 'in-person' ? 'In-Person' : 'Virtual',
              tour_length: '30 Minutes',
              tour_summary: finalTourSummary,
              custom_notes: customNotes,
            },
          ],
        },
        userInfo,
        selectedTourType,
        (msg) => {
          console.error('Booking error callback:', msg);
          toast.error(msg);
        }
      );
      
      setIsAppointmentLoading(false);
      
      console.log('Booking result:', isBookingSuccessful);
      
      if (isBookingSuccessful) {
        console.log(`✅ BOOKING COMPLETED SUCCESSFULLY - Timestamp: ${Date.now()}`);
        setStep(4);
        toast.success('Tour scheduled successfully!');
      } else {
        console.error('Booking failed - isBookingSuccessful was false');
        console.log(`❌ BOOKING FAILED - Timestamp: ${Date.now()}`);
        toast.error('Failed to schedule appointment. Please try again.');
      }
    } catch (error) {
      setIsAppointmentLoading(false);
      console.error('Error in handleSubmitContactForm:', error);
      console.error('Error stack:', error.stack);
      console.log(`💥 BOOKING ERROR - Timestamp: ${Date.now()}`);
      toast.error(`An unexpected error occurred: ${error.message}. Please try again.`);
    }
  };

  const handleOnGoBack = () => {
    if (step > 1) setStep((prev) => prev - 1);
    else if (onBack) onBack();
    else history.back();
  };
  
  const disableddates = query.get('disableddates');
  const checkDisabledDates = (curr_date) => {
    let bool = false;

    if (disableddates) {
      disableddates?.split(',').map((item) => {
        if (new Date(curr_date).getTime() == new Date(item).getTime()) {
          bool = true;
        }
      });
    }
    return bool;
  };

  // Get today's date in YYYY-MM-DD format for min date
  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  return (
    <WidgetWrapper step={step} showGoBack={showGoBack} onBack={handleOnGoBack}>
      {step === 1 && (
        <div className=" h-full w-full flex items-center justify-center">
          <div className="step-5 w-96	" style={{ width: '384px' }}>
            <div className="meta">
              <div className="title font">Schedule A Tour</div>
              <div className="txt font">Select your tour type </div>
            </div>
            <div className="actions flex aic">
              <button
                className={`action-btn font ${
                  selectedTourType === 'in-person' ? 'active' : ''
                }`}
                onClick={() => setSelectedTourType('in-person')}
              >
                In Person
              </button>
              <button
                className={`action-btn font ${
                  selectedTourType === 'virtual' ? 'active' : ''
                }`}
                onClick={() => setSelectedTourType('virtual')}
              >
                Virtual
              </button>
            </div>
            <div className="calender">
              <Calendar
                minDate={new Date(new Date().getTime() + 60 * 60 * 24 * 1000)}
                onChange={(value) => {
                  if (!(value < new Date())) {
                    setSelectedScheduleDate(value);
                    setSelectedDate(value);
                    setStep(2);
                  }
                }}
                value={selectedScheduleDate}
                tileDisabled={({ activeStartDate, date, view }) =>
                  (saturdaystatus == 'disabled' && date.getDay() === 6) ||
                  (sundaystatus == 'disabled' && date.getDay() === 0) ||
                  checkDisabledDates(date)
                }
              />
            </div>
          </div>
        </div>
      )}
      {step === 2 && (
        <div className="step-6 flex flex-col">
          <div className="meta">
            <div className="title font">Schedule A Tour</div>
            <div className="stamp flex aic color">
              <div className="icon icon-calendar1" />
              <div className="lbl font s14 b3">
                {moment(selectedScheduleDate).format('MMMM Do YYYY')}
              </div>
            </div>
          </div>
          <div className="time-table">
            <div className="tit font s14 black">
              Select a tour time {timezone ? `(${getTimezoneDisplayName(timezone)})` : ''}
            </div>
            <div className="time-list">
              {availablepropertyhours?.map((item, idx) => (
                <div
                  onClick={() => {
                    setSelectedHour(item);
                    setStep(3);
                  }}
                  key={idx}
                  style={{ border: '1px solid #3898ec' }}
                  className={` w-full flex items-center cursor-pointer justify-center text-sm py-2 text-pr  rounded-md   hover:bg-blue-50`}
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
      {step === 3 && (
        <div className="step-4 flex flex-col">
          <div className="meta">
            <div className="title font">Schedule A Tour</div>
            <div className="stamp flex aic color">
              <div className="icon icon-calendar1" />
              <div className="lbl font s14 b3">
                {moment(selectedScheduleDate).format('MMMM Do YYYY')} at{' '}
                {selectedHour} {getTimezoneDisplayName(timezone)}
              </div>
            </div>
            
            {/* Enhanced Contact Form */}
            <ContactForm
              info={userInfo}
              setInfo={setUserInfo}
              onSubmit={handleSubmitContactForm}
              isLoading={isAppointmentLoading}
              cta={'Schedule Tour'}
              messageOff
            />

            {/* Custom Notes Accordion */}
            <div className="scheduler-accordion">
              <button
                onClick={() => setExpandedAccordion(expandedAccordion === 'notes' ? null : 'notes')}
                className="scheduler-accordion-button"
              >
                <span className="scheduler-accordion-title">Add Notes (Optional)</span>
                <span className={`scheduler-accordion-chevron ${
                  expandedAccordion === 'notes' ? 'expanded' : ''
                }`}>▶</span>
              </button>
              {expandedAccordion === 'notes' && (
                <div className="scheduler-accordion-content">
                  <textarea
                    className="scheduler-notes-textarea"
                    rows={3}
                    value={customNotes}
                    onChange={(e) => setCustomNotes(e.target.value)}
                    placeholder="Add any special requests or additional information for your tour..."
                  />
                  <div className="scheduler-notes-help-text">
                    These notes will be included with your tour request.
                  </div>
                </div>
              )}
            </div>

            {/* Tour Details Summary */}
            <div className="scheduler-tour-summary">
              <h4 className="scheduler-tour-summary-title">Tour Summary</h4>
              <div className="scheduler-tour-summary-content">
                <div className="scheduler-tour-summary-item">
                  <span className="scheduler-tour-summary-label">Type:</span>
                  {selectedTourType === 'in-person' ? 'In-Person' : 'Virtual'} Tour
                </div>
                <div className="scheduler-tour-summary-item">
                  <span className="scheduler-tour-summary-label">Duration:</span>
                  30 minutes
                </div>
                <div className="scheduler-tour-summary-item">
                  <span className="scheduler-tour-summary-label">Date:</span>
                  {moment(selectedScheduleDate).format('MMMM Do, YYYY')}
                </div>
                <div className="scheduler-tour-summary-item">
                  <span className="scheduler-tour-summary-label">Time:</span>
                  {selectedHour} - {moment(selectedHour, 'hh:mm A').add(30, 'm').format('hh:mm A')} 
                  <span className="scheduler-timezone-display">({getTimezoneDisplayName(timezone)})</span>
                </div>
                {customNotes && (
                  <div className="scheduler-tour-summary-item">
                    <span className="scheduler-tour-summary-label">Notes:</span>
                    {customNotes}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {step === 4 && (
        <ThankYouScreen
          text={`${userInfo.firstname}, thanks for scheduling a tour ${
            magnetSettings
              ? `at \n ${magnetSettings?.communityName}`
              : `at \n ${propertyInfo?.MarketingName}`
          }`}
          magnetSettings={magnetSettings}
          details={{
            selectedDate: selectedScheduleDate,
            selectedHour,
            tourType: selectedTourType,
            timezone: getTimezoneDisplayName(timezone),
            customNotes,
          }}
          onGoBack={() => setStep((prev) => prev - 1)}
        />
      )}
    </WidgetWrapper>
  );
};

export default Scheduler;
